import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { popups } from './Save.model';

const modeColors = {
	drift: {
		background: '#FABE2C',
		text: '#000000',
	},
	comfort: {
		background: '#1782FF',
		text: '#FFFFFF',
	},
	sport: {
		background: '#EB1818',
		text: '#FFFFFF',
	},
};

const StyledHoverBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;
	z-index: 0;

	background-image: radial-gradient(
		circle at center,
		rgba(255, 255, 255, 0.1) 0%,
		rgba(255, 255, 255, 0) 100%
	);
`;

const StyledDot = styled.div`
	position: absolute;
	top: 50%;
	left: -35px;
	transform: translateY(-50%);
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #ffffff;
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	padding: 0 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	z-index: 1;
`;

const StyledTextLabel = styled(Text)<{
	$hover?: boolean;
}>`
	color: #ffffff;
	font-size: 16px;
	z-index: 1;
	transition: all 0.3s ease;
`;

const StyledPopupWrapper = styled.div`
	position: fixed;
	z-index: 9999;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.popup-enter,
	&.hint-enter {
		opacity: 0;
	}

	&.popup-enter-active,
	&.popup-enter-done,
	&.popup-exit,
	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		opacity: 1;
	}

	&.popup-exit-active,
	&.hint-exit-active {
		opacity: 0;
	}
`;

const StyledPopupContainer = styled.div<{ $activePopup: popups }>`
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.9);

	${Text} {
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}
`;

const StyledInfoHintContainer = styled.div`
	z-index: 10000;
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	width: 340px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.9);
	border-radius: 10px;
`;

const StyledInfoHintRowContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledMode = styled.div<{ $mode: 'sport' | 'drift' | 'comfort' }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	background-color: ${(props) => modeColors[props.$mode].background};
	border-radius: 6px;

	${Text} {
		color: ${(props) => modeColors[props.$mode].text};
		font-size: 12px;
		font-weight: 500;

		&::first-letter {
			text-transform: capitalize;
		}
	}
`;

const StyledInfoHintAuthorContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 12px;

	${Text} {
		color: #000;
		font-size: 14px;
		font-weight: 500;
	}

	img {
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
	}
`;

export {
	StyledButtonsContainer,
	StyledContainer,
	StyledDot,
	StyledHoverBackground,
	StyledInfoHintAuthorContainer,
	StyledInfoHintContainer,
	StyledInfoHintRowContainer,
	StyledMode,
	StyledPopupContainer,
	StyledPopupWrapper,
	StyledTextLabel,
};
